import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  computed: {},
  methods: {},
  components: {},
})
export default class MyCreateSidebar extends Vue {
  currentRoute = '';
  mounted() {
    this.currentRoute = this.$route.path;
    if (this.currentRoute == '/my-create') {
      this.goTo('/my-create/ask-goover');
    }
  }
  goTo(destination: string) {
    this.$router.push(destination);
  }

  @Watch('$route')
  onRouteChange() {
    this.currentRoute = this.$route.path;
    if (this.currentRoute == '/my-create') {
      this.goTo('/my-create/ask-goover');
    }
  }
}
